import { formatDateToISO } from "./formatDate";

type Serializable = string | number | boolean | null | undefined | SerializableObject | SerializableArray;
interface SerializableObject {
  [key: string]: Serializable;
}
type SerializableArray = Serializable[];

export function serializeFormValues<T>(values: T, ignoreFields: string[] = []): Serializable {
  return serializeValue(values, ignoreFields);
}

function serializeValue(value: unknown, ignoreFields: string[]): Serializable {
  if (value == null) return value as null | undefined;
  if (value instanceof Date) return formatDateToISO(value);
  if (typeof value === "string" || typeof value === "number" || typeof value === "boolean") return value;
  if (value instanceof File || value instanceof Blob) return null;
  if (Array.isArray(value)) {
    return value.map((v) => serializeValue(v, ignoreFields));
  }
  if (typeof value === "object") {
    const result: SerializableObject = {};
    for (const [k, v] of Object.entries(value as Record<string, unknown>)) {
      if (ignoreFields.includes(k)) continue;
      result[k] = serializeValue(v, ignoreFields);
    }
    return result;
  }
  return null;
}

export function deserializeFormValues<T>(raw: unknown, dateFields: string[] = []): Partial<T> {
  if (raw == null || typeof raw !== "object" || Array.isArray(raw)) return {} as Partial<T>;
  return deserializeObject(raw as Record<string, unknown>, dateFields) as Partial<T>;
}

function deserializeObject(obj: Record<string, unknown>, dateFields: string[]): Record<string, unknown> {
  const result: Record<string, unknown> = {};
  for (const [k, v] of Object.entries(obj)) {
    if (dateFields.includes(k) && typeof v === "string" && v !== "") {
      result[k] = new Date(v);
    } else if (v != null && typeof v === "object" && !Array.isArray(v)) {
      result[k] = deserializeObject(v as Record<string, unknown>, dateFields);
    } else if (Array.isArray(v)) {
      result[k] = v.map((item) =>
        item != null && typeof item === "object" && !Array.isArray(item)
          ? deserializeObject(item as Record<string, unknown>, dateFields)
          : item,
      );
    } else {
      result[k] = v;
    }
  }
  return result;
}
